import * as React from "react";
import styled from "styled-components";
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Save from '../../../assets/profile/profile-save.png';
import Splurge from '../../../assets/profile/profile-splurge.png';
import Camera from '../../../assets/profile/profile-camera.png';
import Bag from '../../../assets/profile/profile-bag.png';
import Headphones from '../../../assets/profile/profile-headphones.png';
import Mobile from '../../../assets/profile/profile-mobile.png';
import Laptop from '../../../assets/profile/profile-laptop.png';
import { buttonIcon } from '../../../assets/images';

import { API_BASE_URL } from '../../../config/apiConfig';
const BrandLink = styled.span`
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ListsRequestText = styled.p`
  text-align: center;
  letter-spacing: -0.32px;
  margin-top: 0px;
  font: 400 14px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 0px;
    font-size: 14px;
  }
`;
const SaveButton = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width:260px;  
  text-transform: uppercase;
  @media (max-width: 991px) {
    margin-bottom: 20px;
    width: 100%;
  }

`;
const ButtonIcon = styled.img`
  aspect-ratio: 1.22;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
  margin: auto 0;
`;
const SectionRow = styled.section`
  display: flex;
  flex-direction: row;
  color: #202023;
  gap: 20px;
  line-height: 130%;
  padding: 20px 36px;
  margin-top: 20px;
  width: 800px;
  max-width: 100%;
  @media (max-width: 991px) {
    margin-top: 40px;
    padding: 0 20px;
    flex-direction: column;
  }
`;

const ListSection = styled.article`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  border: 1px solid #202023;
  padding-bottom: 30px;
  align-items: left;
  color: #202023;
  position: relative; /* Added for positioning the images */
  @media (max-width: 991px) {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;

const CameraImage = styled.img`
  position: absolute;
  top: 18%; /* Adjust as needed */
  left: -70px; /* Adjust as needed */
  width: 100px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const BagImage = styled.img`
  position: absolute;
  bottom: 18%; /* Adjust as needed */
  left: -70px; /* Adjust as needed */
  width: 100px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const HeadphonesImage = styled.img`
  position: absolute;
  bottom: 70%; /* Adjust as needed */
  right: -44px; /* Adjust as needed */
  width: 75px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const LaptopImage = styled.img`
  position: absolute;
  bottom: 45%; /* Adjust as needed */
  right: -70px; /* Adjust as needed */
  width: 100px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const MobileImage = styled.img`
  position: absolute;
  bottom: 10%; /* Adjust as needed */
  right: -50px; /* Adjust as needed */
  width: 75px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const EditButton = styled.button`
  border: 1px solid #202023;
  background-color: #e9fe53;
  align-self: flex-end;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  justify-content: center;
  padding: 4px 12px;
  font: 400 12px Metrophobic, sans-serif;
`;

const Header = styled.div`
  letter-spacing: -0.48px;
  padding-left: 40px;
  margin-right: 40px;
  font: 800 24px Inter, sans-serif;
  margin-top: 15px;
  @media (max-width: 991px) {
    padding-left: 20px;  
  }
`;

const SubText = styled.div`
  letter-spacing: -0.28px;
  font: 400 14px Metrophobic, sans-serif;
  align-items: left;
  margin-left: 40px;
  margin-right: 40px;
  white-space: nowrap; /* Ensure text fits in one line */
  @media (max-width: 991px) {
    padding: 0 0;
    margin-left: 20px;
    margin-right: 10px;
  }
`;

const ListImage = styled.img`
  object-fit: contain;
  width: 100%;
  margin-top: 21px;
`;
const HorizontalLine = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #202023;
  margin: 20px 0;
`;
const Description = styled.div`
  letter-spacing: -0.24px;
  font: 400 12px Metrophobic, sans-serif;
  margin-left: 40px;
  margin-right: 40px;
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Add ellipsis for overflow */
  @media (max-width: 991px) {
    padding-right: 20px;
    white-space: initial;
    margin-left: 20px;
    margin-right: 10px;
  }
`;

const ItemList = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-left: 20px;
  margin-right: 20px;
`;

const Item = styled.input`
border: 1px solid rgba(32, 32, 35, 1);
border-radius: 1px;
margin-top: 8px;
width: 80%;
max-width: 100%;
padding: 12px;
letter-spacing: -0.24px;
font:  16px/130% Metrophobic, sans-serif;
margin-left: 20px;
margin-right: 20px;
@media (max-width: 991px) {
  padding-right: 20px;
  white-space: initial;
  margin-left: 0px;
  margin-right: 0px;
  height: 10px;
}
`;

const ItemIndex = styled.span`
  font-family: Metrophobic, sans-serif;
  align-self: start;
`;

const ItemName = styled.span`
  font-family: Metrophobic, sans-serif;
  flex-grow: 1;
`;

function Lists({ profile, navigateToBrands }) {
  const [isEditing, setIsEditing] = React.useState(false);
  const [needItems, setNeedItems] = React.useState(Array.from({ length: 5 }, (_, i) => profile.needList.split(',')[i] || ''));
  const [greedItems, setGreedItems] = React.useState(Array.from({ length: 5 }, (_, i) => profile.greedList.split(',')[i] || ''));
  const [isLoading, setIsLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    setIsEditing(false);
    const validNeedList = needItems;
    const validGreedList = greedItems;

    if (validNeedList.length < 3) {
      setSnackbarOpen(true);
      return;
    }

    setIsLoading(true);
    const token = sessionStorage.getItem('token');
    let body = {
      needList: validNeedList.toString(),
      greedList: validGreedList.toString()
    };

    if (token && body) {
      try {
        const response = await fetch(`${API_BASE_URL}/user/update-profile`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token
          },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.error('Error updating lists', error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  const handleNeedItemChange = (index, value) => {
    const newNeedItems = [...needItems];
    newNeedItems[index] = value;
    setNeedItems(newNeedItems);
  };

  const handleGreedItemChange = (index, value) => {
    const newGreedItems = [...greedItems];
    newGreedItems[index] = value;
    setGreedItems(newGreedItems);
  };

  return (
    <>
      <SectionRow>
        <ListSection>
          <EditButton style={{ display: isEditing ? 'none' : 'block' }} onClick={handleEditClick}>
            EDIT
          </EditButton>
          <Header>Need List</Header>
          <SubText>
            I just can't do without these, need to buy them asap.
          </SubText>
          <HorizontalLine />

          <Description>
            Products that you are likely to purchase immediately or in the near future. At least 3*
          </Description>
          <CameraImage src={Camera} alt="Camera" />
          <ItemList>
            {needItems.map((item, index) => (
              <Item
                type="text"
                value={item || ''}
                key={index}
                prefix={(index + 1).toString() + '.'}
                onChange={(e) => handleNeedItemChange(index, e.target.value)}
                disabled={!isEditing}
              />
            ))}
          </ItemList>
          <BagImage src={Bag} alt="Bag" />
        </ListSection>
        <ListSection>
          <EditButton style={{ display: isEditing ? 'none' : 'block' }} onClick={handleEditClick}>
            EDIT
          </EditButton>
          <Header>Greed List</Header>
          <SubText>
            Everybody has one, I would like to own one someday
          </SubText>
          <HorizontalLine />

          <Description>
            Products you wish to purchase eventually maybe after saving towards it
          </Description>
          <ItemList>
            {greedItems.map((item, index) => (
              <Item
                type="text"
                value={item || ''}
                key={index}
                prefix={(index + 1).toString() + '.'}
                onChange={(e) => handleGreedItemChange(index, e.target.value)}
                disabled={!isEditing}
              />
            ))}
          </ItemList>
          <HeadphonesImage src={Headphones} alt="Headphones" />
          <LaptopImage src={Laptop} alt="Laptop" />
          <MobileImage src={Mobile} alt="Mobile" />
        </ListSection>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
            Need list must have at least 3 items to proceed.
          </Alert>
        </Snackbar>

      </SectionRow>
      
      {isEditing && (
        <SaveButton onClick={handleSaveClick}>
          <span>SAVE CHANGES</span>
          <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
        </SaveButton>
      )}
      
      {!isEditing && (
        <ListsRequestText>
          Request for products from our curated selection of <BrandLink onClick={navigateToBrands}>brands</BrandLink>, to find the perfect fit for your need and greed.
        </ListsRequestText>
      )}
    </>
  );
}


export default Lists; 